const pt = {
  // Header Navigation
  nav: {
    about: "Sobre",
    performance: "Performance",
    onboarding: "Acesso",
    technology: "Tecnologia",
    behindStrategy: "Estratégia",
    pricing: "Preços",
    faq: "FAQ",
    contact: "Contato",
    startOnboarding: "Obter Acesso",
  },

  // Hero Section
  hero: {
    badge: "Robô de Trading Automatizado em Ouro",
    title: "Uma Forma Simples e Inteligente de",
    titleHighlight: "Acessar Trading Automatizado",
    description: "Conecte uma vez. Mantenha o controle. Deixe a automação OPTIMUS fazer o trabalho pesado nos mercados de OURO (XAUUSD) com precisão algorítmica de nível institucional.",
    quote: '"Você sempre mantém o controle da sua conta e capital"',
    learnMore: "Saiba Mais",
    features: {
      transparent: "Performance Transparente",
      support: "Suporte Contínuo",
      control: "Controle Total do Capital",
      community: "Comunidade Exclusiva",
    },
    stats: {
      years: "2.5+",
      yearsLabel: "Anos em Operação",
      clients: "6.000+",
      clientsLabel: "Clientes Ativos",
      global: "Global",
      globalLabel: "Presença Mundial",
      capital: "US$ 12M+",
      capitalLabel: "Capital Total",
    },
  },

  // About Section
  about: {
    sectionTitle: "Sobre",
    title: "O que é",
    titleHighlight: "OPTIMUS",
    description: "OPTIMUS é um robô de trading em Ouro (EA - Expert Advisor) que conecta sua conta de trading ao nosso sistema de trading automatizado independente para gerenciar riscos, eliminar erros humanos e construir renda passiva.",
    cards: {
      automation: {
        title: "Acesso à Automação",
        desc: "Acesse nosso sistema automatizado projetado para performance consistente no mercado de ouro (XAUUSD) sem execução manual de trades pelo usuário. Deixe o OPTIMUS trabalhar por você!\n\nProcesso de acesso fácil e simples.",
      },
      transparency: {
        title: "Transparência e Performance",
        desc: "Visualize dados de performance da estratégia rastreados independentemente através de plataformas de verificação de terceiros. Transparência total em todos os momentos.\n\nConfira nossa conta verificada no MYFXBOOK.",
      },
      referral: {
        title: "Programa de Indicação",
        desc: "OPTIMUS oferece recompensas discricionárias de indicação para pessoas que você apresentar à plataforma. A participação é totalmente opcional.",
      },
    },
    comingSoon: "Em Breve",
    faqLink: "Encontre informações mais detalhadas sobre o OPTIMUS Gold Bot na",
    faqLinkText: "seção FAQ",
  },

  // Performance Section
  performance: {
    sectionTitle: "Performance",
    title: "Performance da Estratégia",
    titleHighlight: "Verificada",
    description: "Visualize a atividade da conta a qualquer momento. As atualizações são automáticas e transparentes, verificadas independentemente.",
    liveData: "Dados Verificados ao Vivo",
    cumulative: "Performance Acumulada",
    avgMonthly: "Variação Média Mensal",
    maxDrawdown: "Drawdown Máximo",
    tracked: "Rastreado Independentemente",
    liveFeed: "Feed de Dados ao Vivo",
    winRate: "Win Rate",
    thisWeek: "Esta Semana",
    thisMonth: "Este Mês",
    thisYear: "Este Ano",
    chartTitle: "Dados de Performance Mensal Verificados",
    chartDisclaimer: "Performance passada não garante resultados futuros.",
    clientsTrades: "Trades dos Clientes",
  },

  // How It Works / Onboarding Section
  howItWorks: {
    sectionTitle: "O Processo",
    title: "Descubra o",
    titleHighlight: "OPTIMUS",
    titleEnd: "",
    description: "Veja mais de perto como os clientes começam sua jornada com o OPTIMUS Gold Bot.",
    steps: {
      step1: {
        title: "Criar Conta na Corretora",
        desc: "Seleção da Corretora / Abrir Conta / Configurar Conta e Depositar\n\nOferecemos uma seleção de diferentes corretoras que você pode escolher para usar com o bot. Instruções passo a passo completas disponíveis.\n\nInvestimento mínimo: €1.050 / US$1.050 / £850",
      },
      step2: {
        title: "Conectar OPTIMUS",
        desc: "Uma vez que sua conta esteja aberta e pronta, você pode conectá-la com segurança ao nosso serviço e deixar a automação fazer seu trabalho.",
      },
      step3: {
        title: "Trading Automatizado Começa",
        desc: "Uma vez conectado, os trades são executados automaticamente com base em regras predefinidas e controles de risco integrados. Nenhuma execução manual de trades é necessária.\n\nAproveite o trading totalmente automatizado!!",
      },
      step4: {
        title: "Monitore a Qualquer Momento",
        desc: "Verifique a performance a qualquer momento e acesse todas as informações sobre sua conta através do app ou do site da corretora. Tudo é transparente e em tempo real.",
      },
    },
    supportIncluded: "Suporte Incluído",
    supportText: "Quando você clicar no botão OBTER ACESSO, será guiado passo a passo pelo nosso processo de onboarding.\nNenhuma configuração técnica é necessária. Tudo é simples.\nSeu dinheiro permanece totalmente sob seu controle em todos os momentos.",
  },

  // Technology Section
  technology: {
    sectionTitle: "Nossa Tecnologia",
    title: "Construído para",
    titleHighlight: "Consistência",
    description: "Um sistema. Execução inteligente. Projetado em torno de princípios operacionais específicos para performance de longo prazo.",
    features: {
      xauusd: { title: "XAUUSD (Ouro Spot)", desc: "A estratégia foca exclusivamente em XAUUSD (ouro spot) e é configurada especificamente para este mercado." },
      scalping: { title: "Estratégia de Scalping Fixa", desc: "Segue uma abordagem de scalping predefinida focada em trades de curta duração para retornos consistentes." },
      exposure: { title: "Exposição de Mercado Curta", desc: "Os trades geralmente duram minutos, limitando a exposição prolongada a condições de mercado voláteis." },
      ai: { title: "Lógica de Entrada Otimizada por IA", desc: "As condições de entrada são geradas usando lógica baseada em regras apoiada por análise de machine learning e múltiplas entradas técnicas." },
      indicators: { title: "Confirmação Multi-Indicadores", desc: "Os sinais de trade são gerados apenas quando múltiplos indicadores técnicos se alinham para máxima precisão." },
      protection: { title: "Proteção Integrada", desc: "Múltiplos mecanismos de proteção predefinidos projetados para limitar a exposição e proteger seu capital." },
      drawdown: { title: "Proteção de Drawdown", desc: "Limite de perda maxima predefinida em 30%, após o qual as posições abertas são automaticamente encerradas." },
      hedging: { title: "Lógica de Hedge Automatizada", desc: "Ordens de hedge geradas automaticamente usando lógica de grid predefinida quando condições específicas são atendidas." },
      frequency: { title: "Frequência de Trade Seletiva", desc: "Com base em dados históricos, a estratégia geralmente executa 2-4 trades por semana priorizando qualidade sobre quantidade." },
    },
  },

  // Behind the Strategy Section
  behindStrategy: {
    sectionTitle: "Por Trás da Estratégia",
    title: "O Que Está Por Trás da",
    titleHighlight: "Taxa de Acerto Histórica de {rate}%",
    description: "OPTIMUS é construído sobre execução disciplinada, gestão de risco estruturada e lógica de mercado baseada em dados.",
    selectiveTrading: {
      title: "Trading Seletivo para Melhor Estabilidade",
      desc1: "OPTIMUS não opera todos os dias. Ele opera apenas quando seus indicadores e condições de mercado se alinham. Alguns dias são ativos, outros podem ficar quietos.",
      desc2: "Isso é normal — OPTIMUS é construído para estabilidade de longo prazo, e isso requer paciência. Esta abordagem seletiva reduz riscos desnecessários e contribui para consistência de longo prazo.",
    },
    riskControl: {
      title: "Controle de Risco Integrado",
      items: ["Sem martingale", "Sem alavancagem agressiva", "Construído para consistência", "Saque a qualquer momento"],
    },
    transparency: {
      title: "Transparência em Tempo Real, Controle Total",
      desc: "Acompanhe cada posição, cada trade e cada movimento diretamente da sua conta através do app ou do acesso ao seu portal.",
      highlight: "OPTIMUS oferece visibilidade total em todos os momentos.",
    },
    fluctuation: {
      title: "Seu Saldo Vai Flutuar, É Normal",
      desc: "P&L flutuante é normal em sistemas de grid — não significa que algo está errado. OPTIMUS está simplesmente gerenciando sua posição.",
      italic: "O que importa é o ciclo completo, não o ruído diário.",
    },
    noIntervention: {
      title: "Nenhuma Intervenção Necessária",
      desc: "Uma vez ativado, o sistema opera sozinho. Nenhum ajuste manual é necessário — apenas monitore se quiser.",
    },
    whenNotTrade: {
      title: "Quando OPTIMUS",
      titleHighlight: "Escolhe Não Operar",
      marketConditions: { title: "Condições de Mercado Não Ideais", desc: "Se a volatilidade ou estrutura não está certa, OPTIMUS espera. Isso protege seu capital e evita exposição desnecessária." },
      gridSetup: { title: "Configuração de Grid Não Ideal", desc: "O robô verifica se o grid pode ser implantado com segurança. Se a estrutura está muito ampla ou instável, ele escolhe não operar." },
      events: { title: "Eventos", desc: "Após movimentos fortes de preço ou eventos econômicos, OPTIMUS pausa. Ele espera o mercado estabilizar antes de reengajar." },
    },
    cta: {
      title: "Nunca É Tarde Demais A Menos Que Você",
      titleHighlight: "Continue Esperando",
      desc: "Junte-se a milhares de pessoas já usando OPTIMUS hoje.",
      exclusive: "OPTIMUS é um produto institucional sendo oferecido ao mercado de varejo pela primeira vez.",
      exclusiveHighlight: "Não perca esta oportunidade!",
      faqNote: "Você pode encontrar informações mais detalhadas na",
      faqLink: "seção FAQ",
    },
  },

  // Pricing Section
  pricing: {
    sectionTitle: "Taxa de Serviço",
    title: "Clara. Justa.",
    titleHighlight: "Baseada em Resultados.",
    description: "As taxas se aplicam apenas quando performance líquida positiva é registrada durante o período.\nVocê só paga por novos lucros.",
    performanceFee: "Taxa de Performance",
    serviceFee: "Taxa de serviço sobre lucros líquidos",
    minimumInvestment: "Investimento mínimo: €1.050 / US$1.050 / £850",
    additionalCost: "Custo adicional: subscrição mensal de US$8.00 na plataforma Metacopier.",
    benefits: {
      fee: { title: "30% de Taxa de Serviço", desc: "Uma única taxa sobre lucros líquidos realizados, liquidada diariamente." },
      community: { title: "Comunidade Exclusiva", desc: "Acesso a comunidade exclusiva no Telegram." },
      resultsBased: { title: "Apenas Baseado em Resultados", desc: "Nenhuma taxa é cobrada a menos que a performance líquida seja positiva." },
    },
  },

  // Testimonials Section
  testimonials: {
    sectionTitle: "Histórias de Sucesso",
    title: "O Que os Usuários Dizem Sobre",
    titleHighlight: "OPTIMUS",
    items: [
      { name: "Sarah J.", role: "Cliente Verificado", text: "Já tentei vários bots de trading automatizado, mas OPTIMUS é o único que entrega resultados consistentes sem estresse. As atualizações diárias são fantásticas." },
      { name: "Michael C.", role: "Cliente Verificado", text: "A transparência foi o que me convenceu. Poder ver os resultados ao vivo verificados independentemente antes de depositar me deu total confiança. Melhor investimento que fiz este ano." },
      { name: "Emma T.", role: "Cliente Verificado", text: "Renda passiva sempre foi um sonho até encontrar OPTIMUS. Agora minha conta cresce enquanto foco no meu negócio. A equipe de suporte também é incrivelmente prestativa." },
    ],
  },

  // FAQ Section
  faq: {
    sectionTitle: "FAQ",
    title: "Perguntas",
    titleHighlight: "Frequentes",
    description: "Tudo o que você precisa saber sobre o trading automatizado do Optimus.",
    categories: {
      general: {
        title: "Informações Gerais",
        items: [
          { q: "O que é Optimus e o que a estratégia automatizada faz?", a: "Optimus fornece acesso a uma estratégia de trading automatizada que se conecta à sua conta de corretora e executa trades com base em uma estratégia algorítmica predefinida. Você não precisa fazer trades manualmente ou analisar gráficos; o sistema opera autonomamente uma vez conectado." },
          { q: "Preciso fazer algo uma vez que o robô está ativo?", a: "Não. Uma vez ativo, a automação funciona independentemente. O robô é totalmente automático e ajustará tudo por conta própria. Você é livre para monitorar sua conta de corretora e gerenciar seus fundos a qualquer momento." },
          { q: "Quais são as taxas para usar Optimus?", a: "Não há custos iniciais ou taxas de assinatura — nós só ganhamos se você ganhar. Uma taxa de performance (divisão de lucros) de 30% é automaticamente deduzida dos lucros realizados no final do dia de trading." },
        ],
      },
      security: {
        title: "Segurança e Controle de Fundos",
        items: [
          { q: "Optimus manipula ou acessa meu dinheiro?", a: "Não. Optimus nunca detém ou controla seus fundos. Seu dinheiro fica na sua própria conta de corretora, totalmente sob seu controle. Optimus não pode mover ou sacar seu dinheiro." },
          { q: "Posso sacar meu dinheiro a qualquer momento?", a: "Sim. Como seus fundos permanecem na sua conta pessoal de corretora, você pode sacá-los sempre que quiser." },
        ],
      },
      strategy: {
        title: "Estratégia e Performance",
        items: [
          { q: "Qual é a estratégia de trading?", a: "O robô foi criado por uma talentosa equipe de traders veteranos e custou cerca de 7 dígitos em investimento, sendo desenvolvido em parceria com uma gestora de ativos canadense. O OPTIMUS emprega uma estratégia avançada de scalping fixo com exposição mínima ao mercado. Através de otimização por IA, 13 indicadores customizados e 7 mecanismos de proteção para selecionar os pontos de entrada mais ótimos. O trading ocorre em horários específicos baseados em padrões históricos, garantindo consistência e limitação de risco. Com o protetor de equity stop integrado de 30%, o capital permanece protegido enquanto a estratégia capitaliza com trades curtos e eficientes, durando em média 5 minutos. Esta combinação única de tecnologia e gestão de risco entrega rentabilidade excepcional com exposição de mercado limitada. O robô adicionará automaticamente ordens de hedge em uma função de sistema de grid, em outros pontos de entrada baseados em confluências." },
          { q: "Quais ativos são negociados?", a: "A estratégia é especificamente otimizada para XAUUSD (Ouro). Embora o robô seja projetado para funcionar em outros pares, esses serão lançados no futuro." },
          { q: "Com que frequência o robô opera?", a: "Em média, o robô opera 3 a 4 vezes por semana. Ele prioriza qualidade sobre quantidade, operando apenas em horários específicos e em ambientes de mercado seguros. Se o mercado está instável ou notícias econômicas importantes são esperadas, Optimus não operará." },
          { q: "Onde posso ver a performance ao vivo?", a: "Priorizamos a transparência. Você pode visualizar lucros históricos, drawdowns e frequência de trades através da nossa conta pública verificada no Myfxbook, uma plataforma de terceiros para rastreamento independente de dados.", badge: "Em Breve" },
        ],
      },
      risk: {
        title: "Gestão de Risco",
        items: [
          { q: "Como o risco é gerenciado?", a: "O sistema inclui um Protetor de Equity Stop integrado de 30%. Isso significa que se um drawdown de 30% for atingido, as posições abertas são encerradas automaticamente para proteger seu capital. Importante notar que o robô tem outros 7 mecanismos de proteção obtendo perdas pequenas em entradas que não forem bem sucedidas. O mecanismo de Protetor de Equity Stop de 30% é um ultimo recurso de proteção e é utilizado muito raramente." },
          { q: "Posso ajustar meu risco?", a: "Sim. Embora o padrão seja 30%, você pode ajustar este limite a qualquer momento para se adequar às suas preferências pessoais de risco." },
          { q: "Performance passada é garantida?", a: "Não. Embora o sistema tenha apresentado uma média de 7.8% de retorno mensal em 2025, performance passada não é um indicador confiável de resultados futuros. Trading envolve risco significativo para seu capital." },
        ],
      },
      setup: {
        title: "Configuração e Compatibilidade",
        items: [
          { q: "Quais corretoras posso usar?", a: "Optimus tem parceria com três corretoras regulamentadas para garantir integração segura e acesso ao sistema. Você deve abrir uma nova conta exclusivamente usando os links oficiais do Optimus fornecidos durante o processo de adesão para garantir acesso ao sistema do OPTIMUS." },
          { q: "Qual alavancagem é necessária?", a: "Uma alavancagem mínima de 1:200 (até 1:500) é necessária. Alavancagem de varejo padrão (1:30) é insuficiente para esta estratégia operar." },
          { q: "Posso usar isso com uma Prop Firm?", a: "Não. Optimus não é nativamente projetado para contas de Prop Firm. Qualquer tentativa de usá-lo para este propósito é feita por conta e risco do usuário." },
          { q: "Qual o investimento mínimo?", a: "O investimento mínimo para começar a usar o OPTIMUS é de €1.050 / US$1.050 / £850. Este valor é necessário para garantir que a estratégia opere de forma eficaz com gestão de risco adequada." },
        ],
      },
    },
  },

  // Footer
  footer: {
    description: "Sistema de Trading Automatizado de Ouro. Conecte uma vez. Mantenha o controle. Deixe a automação fazer o trabalho pesado nos mercados XAUUSD.",
    quickLinks: "Links Rápidos",
    legal: "Legal",
    legalLinks: {
      privacy: "Política de Privacidade",
      terms: "Termos de Serviço",
      risk: "Divulgação de Riscos",
      cookie: "Política de Cookies",
    },
    instagramCommunity: "Comunidade Confraria do Trader",
    copyright: "OPTIMUS. Todos os direitos reservados.",
    riskWarning: "Aviso de Risco: Trading de ouro e forex envolve risco significativo. Performance passada não é indicativa de resultados futuros. Opere apenas com capital que você pode perder.",
  },

  // Contact Section
  contact: {
    sectionTitle: "Contato",
    title: "Entre em",
    titleHighlight: "Contato",
    description: "Tem dúvidas sobre o OPTIMUS? Estamos aqui para ajudar. Preencha o formulário abaixo e nossa equipe entrará em contato o mais breve possível.",
    form: {
      name: "Seu Nome",
      namePlaceholder: "Digite seu nome completo",
      email: "Endereço de Email",
      emailPlaceholder: "Digite seu email",
      message: "Mensagem",
      messagePlaceholder: "Como podemos ajudá-lo?",
      submit: "Enviar Mensagem",
    },
    successMessage: "Obrigado pela sua mensagem! Entraremos em contato em breve.",
    errorMessage: "Erro ao enviar mensagem. Por favor tente novamente.",
  },

  // Client Trades Page
  clientTrades: {
    sectionTitle: "Transparência",
    title: "Atividade de Trades dos",
    titleHighlight: "Clientes",
    description: "Exemplos de execução de trades ao vivo de contas conectadas ao sistema de trading automatizado.",
    disclaimer: "As capturas de tela são fornecidas apenas para fins de transparência e demonstração. A atividade e os resultados individuais da conta variam.",
    backToHome: "Voltar ao Início",
    copyright: "OPTIMUS. Todos os direitos reservados.",
    riskWarning: "Aviso de Risco: Trading de ouro e forex envolve risco significativo. Performance passada não é indicativa de resultados futuros. Opere apenas com capital que você pode perder.",
  },

  // Language Selector
  languageSelector: {
    en: "English",
    pt: "Português",
  },

  // Get Access Page
  getAccess: {
    backToHome: "Voltar ao Início",
    sectionTitle: "Obter Acesso",
    title: "Processo de",
    titleHighlight: "Adesão",
    description: "Siga as etapas abaixo para ativar o sistema de trading automatizado OPTIMUS na sua conta.",
    disclaimerTitle: "Leia Antes de Aderir",
    disclaimerText: "Antes de começar, certifique-se de ler atentamente todos os avisos legais. Esses avisos descrevem como o OPTIMUS funciona, os requisitos para acesso e as regras que devem ser seguidas. Negociações em forex envolvem risco significativo. Opere apenas com capital que você pode perder.",
    chooseBroker: "Escolha a Sua Corretora",
    chooseBrokerDesc: "Abra a sua conta na corretora escolhida usando o link fornecido.",
    chooseBrokerNote: "Não é possível criar uma conta diretamente no site da corretora. Para obter acesso ao OPTIMUS, você deve se cadastrar usando o link oficial fornecido nos botões acima.",
    regCtaTitle: "Pronto para iniciar o processo de adesão?",
    regCtaDesc: "Registre-se para acompanharmos cada etapa do seu processo e receberá orientações por email.",
    regCtaButton: "Quero ativar o OPTIMUS",
    regFormTitle: "Iniciar Processo de Adesão",
    regFormDesc: "Informe seus dados para iniciarmos o acompanhamento do seu processo de ativação.",
    regFormNamePlaceholder: "Nome completo",
    regFormEmailPlaceholder: "Email",
    regFormBrokerLabel: "Corretora selecionada:",
    regFormSubmit: "Confirmar e Iniciar",
    regFormSubmitting: "Registrando...",
    regSuccessTitle: "Processo iniciado com sucesso!",
    regSuccessDesc: "Verifique seu email — enviamos um guia com informações importantes para concluir cada etapa.",
    regAlreadyTitle: "Você já está registrado!",
    regAlreadyDesc: "Seu processo de adesão já foi iniciado anteriormente. Continue com os passos abaixo.",
    openAccount: "Abrir Conta",
    step1Title: "Crie a Sua Conta",
    selectBrokerPrompt: "Selecione uma corretora acima para ver as instruções passo a passo.",
    openAccountAt: "Abrir Conta (Link Oficial)",
    progressSteps: ["Corretora", "Config.", "Depósito", "Teste", "Ativação", "Copier"],
    brokers: {
      vantage: {
        step1Instructions: [
          "Abra o link e crie a sua conta usando o seu e-mail e senha.",
          "Insira o seu país.",
          "Deixe o campo \"REFERRED BY\" em branco.",
          "Aceite os termos e clique em \"Create Account\".",
        ],
        step1Emails: "",
        step1EmailItems: [],
        step1Download: "Você pode baixar o app MetaTrader 5 no site da corretora:",
        step1DownloadButton: "Baixar MetaTrader 5",
        step2Desc: "Após iniciar o processo de abertura da conta e inserir as suas informações pessoais, é necessário configurar as definições listadas abaixo:",
        step2Emails: "Depois que concluir a abertura da conta, você receberá e-mails de confirmação da Vantage, dentre eles:",
        step2EmailItems: [
          "E-mail para confirmar o seu endereço de e-mail.",
          "E-mail com as suas credenciais de login do MetaTrader 5.",
        ],
        step2ConfigItems: [
          "Plataforma: MetaTrader 5",
          "Tipo de Conta: RAW ECN",
          "Alavancagem Mínima: 1:300",
        ],
        step3Desc: "Faça login para acessar sua conta, clique em \"Depositar\" ou \"Fundos\".",
        step3ExtraItems: [
          "Confirme a conta que receberá o depósito.",
          "Informe o valor desejado para o depósito.",
          "Escolha a forma da transferência de preferência.",
          "Revise se os detalhes do seu depósito estão corretos e finalize o depósito.",
        ],
      },
      vtmarkets: {
        step1Instructions: [
          "Abra o link e crie a sua conta usando o seu e-mail e senha.",
          "Insira o seu país.",
          "Deixe o campo \"REFERRED\" em branco.",
          "Clique em \"Open a live Account\".",
        ],
        step1Emails: "",
        step1EmailItems: [],
        step1Download: "Você pode baixar o app MetaTrader 5 no site da corretora:",
        step1DownloadButton: "Baixar MetaTrader 5",
        step1DownloadNote: "Encontre a plataforma MetaTrader 5 e clique em \"START NOW\".",
        step2ConfigItems: [
          "Plataforma: MetaTrader 5",
          "Tipo de Conta: RAW ECN (Ou Standard STP dependendo do seu país - Ambos válidos)",
          "Alavancagem Mínima: 1:300",
        ],
        step2Desc: "Após iniciar o processo de abertura da conta e inserir as suas informações pessoais, é necessário configurar as definições listadas abaixo:",
        step2Emails: "Depois que concluir a abertura da conta, você receberá e-mails de confirmação da VT Markets, dentre eles:",
        step2EmailItems: [
          "E-mail para confirmar o seu endereço de e-mail.",
          "E-mail com as suas credenciais de login do MetaTrader 5.",
        ],
        step3Desc: "Faça login para acessar sua conta, clique em \"Depositar\" ou \"Fundos\".",
        step3ExtraItems: [
          "Confirme a conta que receberá o depósito.",
          "Informe o valor desejado para o depósito.",
          "Escolha a forma da transferência de preferência.",
          "Revise se os detalhes do seu depósito estão corretos e finalize o depósito.",
        ],
      },
      puprime: {
        step1Instructions: [
          "Abra o link e crie a sua conta usando o seu e-mail e senha.",
          "Insira o seu país.",
          "Deixe o campo \"REFERRED BY\" em branco.",
          "Aceite os termos e clique em \"Create Account\".",
        ],
        step1Emails: "",
        step1EmailItems: [],
        step1Download: "",
        step1DownloadButton: "",
        step2Desc: "Após iniciar o processo de abertura da conta e inserir as suas informações pessoais, é necessário configurar as definições listadas abaixo:",
        step2Emails: "Depois que concluir a abertura da conta, você receberá e-mails de confirmação da PU Prime, dentre eles:",
        step2EmailItems: [
          "E-mail para confirmar o seu endereço de e-mail.",
          "E-mail com as suas credenciais de login do MetaTrader 5.",
        ],
        step2ConfigItems: [
          "Plataforma: MetaTrader 5",
          "Tipo de Conta: STANDARD",
          "Alavancagem Mínima: 1:300",
        ],
        step3Desc: "Faça login para acessar sua conta, clique em \"Depositar\" ou \"Fundos\".",
        step3ExtraItems: [
          "Confirme a conta que receberá o depósito.",
          "Informe o valor desejado para o depósito.",
          "Escolha a forma da transferência de preferência.",
          "Revise se os detalhes do seu depósito estão corretos e finalize o depósito.",
        ],
      },
    },
    step2Title: "Configurar a Conta",
    step2Desc: "Após a abertura da conta, faça as configurações listadas abaixo:",
    step2ConfigTitle: "CONFIGURAÇÕES IMPORTANTES:",
    step2Note: "Certifique-se de que todas as configurações correspondem à configuração recomendada para um desempenho ideal com o OPTIMUS.",
    step3Title: "Depositar na Conta",
    step3Desc: "Faça login para acessar sua conta e clique em \"Depósito\" ou \"Fundos\".",
    step3InfoTitle: "INFORMAÇÕES IMPORTANTES:",
    step3Items: [
      "Depósito mínimo: €1.050 / $1.050 / £850",
      "O depósito deve ser feito em uma única transação, sem divisão.",
      "Capital máximo recomendado por conta: $25.000 (Se você investir mais capital, divida em várias contas).",
    ],
    step4Title: "Operação Teste",
    step4QrLabel: "Escaneie o QR Code com a câmera do seu celular para baixar o MetaTrader 5:",
    step4QrCaption: "Abre automaticamente na App Store ou Google Play",
    step4Desc: "Após depositar seus fundos, você precisa verificar se sua conta está configurada corretamente e pronta para ativação.\nPara isso, você precisará realizar uma operação de teste de confirmação.\nSiga estes passos:",
    step4Steps: [
      "Baixe e instale o aplicativo MetaTrader 5 no seu celular.",
      "Abra o MetaTrader 5 e selecione o par EURUSD.",
      "Coloque uma ordem de compra ou venda neste par com um lote de 1.0.",
      "Deixe a negociação correr por 15 a 30 segundos e, em seguida, feche-a.",
      "Faça uma captura de tela da operação teste fechada para ser enviada no passo 05.",
    ],
    step4Note1: "Você pode ter um pequeno lucro ou prejuízo durante este processo, mas isso não afetará significativamente seu saldo.",
    step4Note2: "Esta etapa é importante para habilitar sua conta corretamente.",
    step4Note3: "Após esta etapa, você estará quase pronto para começar e será ativado em breve!",
    step4GuideButton: "Acessar Guia Detalhado",
    step4GuideSoon: "Em Breve",
    step4ImportantTitle: "INFORMAÇÕES IMPORTANTES:",
    step4ImportantItems: [
      "No App do MetaTrader 5 você pode acompanhar as operações em tempo real e todas as informações relativas a conta e saldo.",
      "Nunca opere manualmente sua conta conectada ao OPTIMUS. Isso poderá acarretar em mal funcionamento.",
    ],
    step5Title: "Enviar Informações para Ativação",
    step5Desc: "Faça o envio das informações de confirmação para avançar a ativação:",
    step5Items: [
      "Nome completo",
      "Número de ID da conta",
      "Anexar a captura de tela do seu trade de teste de confirmação",
    ],
    step5Important: "Certifique-se de que a foto da captura de tela esteja NÍTIDA para efetuarmos a verificação necessária EVITANDO ATRASOS.",
    step5FormName: "Nome Completo",
    step5FormNamePlaceholder: "Digite seu nome completo",
    step5FormEmail: "Email Cadastrado na Corretora",
    step5FormEmailPlaceholder: "Digite o email cadastrado na corretora",
    step5FormBrokerName: "Nome da Corretora Escolhida",
    step5FormBrokerNamePlaceholder: "Ex: Vantage, VT Markets, PU Prime",
    step5FormAccountId: "Número de ID da Conta",
    step5FormAccountIdPlaceholder: "Digite o ID da sua conta",
    step5FormScreenshot: "Captura de Tela da Operação Teste Fechada",
    step5FormScreenshotBtn: "Escolher Arquivo",
    step5FormSubmit: "Enviar Confirmação",
    step5FormSubmitting: "A enviar...",
    step5FormSuccess: "Confirmação enviada com sucesso! Iremos analisar as suas informações e ativar a sua conta em breve.",
    step5FormError: "Erro ao enviar. Por favor tente novamente.",
    step6Badge: "Etapa Final",
    step6Title: "Configuração MetaCopier",
    step6Intro: "Agora que sua conta já está liberada e ativada, precisamos conectá-la ao OPTIMUS.",
    step6Desc: "Nesta etapa final, vamos configurar a \"ponte\" que leva as ordens do nosso sistema até a sua conta, para que as operações da nossa estratégia sejam replicadas na sua conta em tempo real. Para isso, usamos uma plataforma líder no mercado que garante que você receba as operações feitas pela conta do OPTIMUS no mesmo milissegundo em sua conta, com a menor latência possível.",
    step6Email: "Após a ativação de sua conta no passo 05, você receberá um email exclusivo com o assunto: \"Instruções de Configuração - Metacopier & OPTIMUS\" com as instruções detalhadas para realizar a configuração do Metacopier.",
    step6After: "Ao finalizar esta etapa, sua conta passará a replicar as operações do OPTIMUS automaticamente.",
    step6CostLabel: "Custos",
    step6CostText: "A empresa Metacopier cobra uma subscrição à parte, de US$8.00 por mês pela utilização de seus serviços.",
    step6Help: "Tem alguma dúvida? Fique à vontade para nos perguntar através do formulário em nosso site, ou do email info@optimusgoldbot.com, ou ainda no direct Instagram da Confraria do Trader. Boa sorte!",
    needHelp: "Precisa de ajuda?",
    needHelpText: "Contacte-nos através de",
    riskWarning: "Aviso de Risco: Trading de ouro e forex envolve risco significativo. Performance passada não é indicativa de resultados futuros. Opere apenas com capital que você pode perder.",
  },
};

export default pt;
